<script>
import appConfig from "@/app.config";
import paymentOffre from "@/services/payment_offre-api"

export default {
  page: {
    title: "Page de paiement",
    meta: [{ name: "description", content: appConfig.description }]
  },
  props : {
    message:{
          type:String,
          default: null,
      },
    isSuccess:{
        type:Boolean,
        default: null,
    },

  },

  data() {
    return{
      paymentOffreList: [],
      paymentOffreServicesList: [],
      pagemodelMainpaymentOffre: {currentPage : 1, perPage : 3, totalRows: 0},
      isOffreListListBusy:false,
      isPaymentDetailsBusy:false,
      isprocessingPaymentValid:false,
      processingPayment: [],
    }
  },

  mounted() {
    this.findPaymentOffre();
   
  },

  methods: {
    findPaymentOffre() {
  this.isOffreListListBusy = true;
  paymentOffre.getPaymentOffre(this.pagemodelMainpaymentOffre.currentPage, this.pagemodelMainpaymentOffre.perPage)
    .then((result) => {
      this.paymentOffreList = result.list;
      this.pagemodelMainpaymentOffre.totalRows = result.total;
      this.pagemodelMainpaymentOffre.currentPage = result.page;
      this.pagemodelMainpaymentOffre.perPage = result.pageSize;
      this.pagemodelMainpaymentOffre.pageSize = result.pageSize;
    })
    .catch((error) => {
      console.error('Error fetching payment offers:', error);
      // Handle the error, e.g., show a user-friendly message
    })
    .finally(() => {
      this.isOffreListListBusy = false;
    });
},
findPaymentDetails() {
  this.isPaymentDetailsBusy = true;
  paymentOffre.getPaymentDetails()
    .catch((error) => {
      console.error('Error fetching payment offers:', error);
      // Handle the error, e.g., show a user-friendly message
    })
    .finally(() => {
      this.isPaymentDetailsBusy = false;
    });
},
async postPaymentTransaction(OffreId){
    this.isprocessingPaymentValid =false,
    paymentOffre.addPaymentOffre(OffreId)
    .then((result) => {
      console.info('result.paymentUrl', result.paymentUrl);

      //window.open(result.paymentUrl, '_blank');
      window.location.href = result.paymentUrl;
    })
    .catch((error) => {
      console.error('There is an error while processing payment transactions.', error);
      // Handle the error, e.g., show a user-friendly message
    })
    .finally(() => {
      this.isprocessingPaymentValid =true;
    });
  
  }
  }
};
</script>

<style>
.cad-container {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.cad {
  border-radius: 20px;
  margin: 16px;
  overflow: hidden;
}

.car-image {
  width: 100%;
  height: auto;
}

.cad-content {
  padding: 16px;
}

.cad-title {
  margin-bottom: 8px;
  text-align: center;
}

.cad-text {
  font-size: 1rem;
  color: #555;
}

.trending-content a span.img-marq {
    display: inline-block;
    line-height: 1;
    margin-right: 15px;
    position: relative;
}

.child{
    font-family: 'Lato', sans-serif;
    font-size:14px;
    font-weight:bold;
  width:350px;
  height:60px;
  line-height:60px;
  display:inline-block;
  vertical-align:middle;
  
}

.slick-arrow:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.slick-next:before {
    font-family: 'slick';
    font-size: 20px;
    line-height: 1;
    opacity: 0.75;
    color: #787a76;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.newitems .simplebar-scrollbar::before {
  background-color: #297a54;
}


</style>

<template>
<div>
    <div v-if="message" class="row mt-4 pt-4 mb-4"> 
      <div  class="col-lg-12 text-center">
        <p class="font-size-20 pt-2 mt-4" :class="isSuccess ? 'text-primary' : 'text-danger' "> {{ message }} </p>

        <a v-if="!isSuccess" href="/payment" class="btn btn-danger text-uppercase mt-4">Retour à la page de paiement</a>
        <a v-else href="/" class="btn btn-primary text-uppercase font-weight-bold mt-4">Retour à la page d'accueil</a>
        
      </div>
   </div>

    <div v-if="!message && !isSuccess" class="row mt-4 pt-4 mb-4"> 
     
      <div v-if="message" class="col-lg-12 text-center">
        <p class="font-size-20 font-weight-bold text-uppercase pt-2 mt-4" :class="isSuccess ? 'text-success' : 'text-danger' "> {{ message }} </p>
    </div>
     
      <div  class="col-lg-4 p-4 mt-4 pt-4" > 

        <img src="@/assets/images/logo.png" alt height="80" class="mb-4" />

        <h2 class="font-size-25 text-primary font-weight-bold text-uppercase" style="font-size:25px; letter-spacing: 2px;">Forfaits Annuels LGP</h2>
            <p class="font-weight-bold font-size-14 text-primary">
                consulter et règler en ligne vos forfaits annuels
            </p>

            <p class=" font-size-14 pt-4 mt-4 text-dark text-justify">
              En vous inscrivant sur notre plateforme, vous accédez à un éventail complet d'offres d'achats permanentes, provisoires et groupées, agrémentées de remises et de gratuités particulièrement intéressantes.
            </p>

            <p class=" font-size-14 pt-2 mt-4 text-dark text-justify">
              Les paiements par cartes bancaires sont assurés par des services sécurisés. Vous pouvez effectuer vos transactions en toute confiance.
            </p>

            <p class=" font-size-14 pt-2 mt-4 text-dark text-justify">
                Nous vous remercions de votre confiance !  
            </p>


            
      </div>
      
      <div  v-for="(forfait, index) in paymentOffreList" :key="index" class=" col-lg-4 col-md-12 col-sm-12 mt-4 pt-4" >
    
    
        <div class="col-4 mx-auto" style="box-shadow: rgb(133, 127, 127) 1px 8px 17px; max-width: 400px; border-radius:0px; border-top:5px solid #34c38f;">
          
            <b-card header-class="bg-white border-light " class="mx-auto" style="max-width: 400px; border-radius:8px">
        
              <template v-slot:header>
                <div class="row mt-3 mb-3">
                  <div class="col col-12">
                    <h3 class="my-0 text-success font-weight-bold" style="font-weight:900; font-size:24px">{{ forfait.title }}</h3>
                    <p style="height:50px;" class="my-0 mt-3 text-justify text-dark font-size-16">{{ forfait.description }}</p>
                  </div>
                </div>
              </template>

             
                <div class="row">
                  <div class="col-12">
                    <h2 class="text-success text-uppercase text-left" style="font-size:55px;" >{{forfait.dailyPrice}} <span class="text-dark" style="font-size:35px;"> <span class="text-success">HT </span> <span style="font-size:25px;">/</span> jour</span> </h2>
                  </div>
                </div> 

                <div class="row mt-4">
                  <div class="col-12">
                    <p style="height:50px;" class="text-dark text-left text-justify font-size-16"> Soit <strong>{{ forfait.subscriptionRate }} DT TTC</strong> pour la période du {{ forfait.startDate }} au {{ forfait.endDate }}  </p>

                  </div>
                </div> 

                <div class="row mt-4 ml-2" style="height: 180px;">
                  <div class="col-12">
                    <div v-for="(service, index) in forfait.services.split(';')" :key="index"  >
                        <div class="row mb-3">
                          <div class="col-12">
                            <i class="fas fa-check-double font-size-12 align-middle mr-2"></i>
                            <span class="font-size-14"><i>{{ service }}</i></span>
                          </div>
                        </div>
                      </div>
                  </div>
                </div> 

                <div class="row mt-4">
                  <div class="col-12">
                    <b-button variant="info" class="w-100" @click="postPaymentTransaction(forfait.id)">
                      <strong class="font-size-16 " style="letter-spacing:2px;">PAYER CE FORFAIT</strong>
                    </b-button>
                  </div>
                </div> 

      </b-card>
    </div>
  
  

    </div>
    </div>

  </div>

</template>